import { ITagTextColorSliceData } from 'components/MCTextEditor/formatting/interfaces/tagTextColorSliceData'
import { SliceType } from 'components/MCTextEditor/slice/types'
import {
  ISlice,
  SliceComparator,
  SliceWithoutRange,
} from 'components/RichTextEditor/processor/constants'

export const slicesEqual: SliceComparator = (a, b) => {
  if (a.type === SliceType.TEXT_COLOR) {
    return isTextColorSlicesEqual(a, b)
  } else if (
    a.type === SliceType.BOLD ||
    a.type === SliceType.ITALIC ||
    a.type === SliceType.UNDERLINE
  ) {
    return a.type === b.type
  }
  if (a.id) {
    return a.id === b.id
  }
  return a === b
}

const isTextColorSlicesEqual = (a: SliceWithoutRange, b: SliceWithoutRange): boolean => {
  if (a.type !== SliceType.TEXT_COLOR || b.type !== SliceType.TEXT_COLOR) {
    return false
  }

  const colorSlice1 = a as Partial<ISlice<ITagTextColorSliceData>>
  const colorSlice2 = b as Partial<ISlice<ITagTextColorSliceData>>
  if (colorSlice1.data?.color === colorSlice2.data?.color) {
    return true
  }

  return false
}
